import {
  RESEND_MAIL_SUCESS,
} from './types';
import { STATUS } from '../../config/constants/states';

const initialState = {
  resendSucess: STATUS.PENDING,
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case RESEND_MAIL_SUCESS:
      return { ...state, resendSucess: payload };
    default:
      return state;
  }
};